import RegisterProfile from './RegisterProfile'

export default RegisterProfile
